/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Basicinfo1Inputs */

const en_settings_basicinfo1 = /** @type {(inputs: Settings_Basicinfo1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basic info`)
};

/**
* | output |
* | --- |
* | "Basic info" |
*
* @param {Settings_Basicinfo1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_basicinfo1 = /** @type {((inputs?: Settings_Basicinfo1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Basicinfo1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_basicinfo1(inputs)
});
export { settings_basicinfo1 as "settings_basicInfo" }